var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLazadaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 807,
    height: 656,
    viewBox: "0 0 807 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2370_911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.624 655.109C397.889 655.145 392.25 653.673 387.269 650.859C344.586 626.159 28.4774 427.959 16.5405 421.913C12.0713 419.831 8.21601 416.629 5.34843 412.618C2.48085 408.607 0.698256 403.923 0.173496 399.021V121.01C0.0615424 115.906 1.25017 110.857 3.62749 106.34C6.00482 101.822 9.49266 97.9828 13.7627 95.1846L16.0376 93.8795C46.6284 74.9025 148.997 12.4279 165.196 3.43622C168.909 1.23228 173.138 0.0469881 177.456 0C181.503 0.0478916 185.478 1.05362 189.07 2.94533C189.07 2.94533 332.314 96.322 354.236 104.655C369.61 111.716 386.374 115.235 403.289 114.952C422.464 115.354 441.41 110.731 458.245 101.542C479.652 90.2757 616.539 3.4482 617.999 3.4482C621.447 1.36491 625.422 0.28735 629.445 0.335241C633.768 0.359187 638.006 1.5445 641.706 3.77146C660.347 14.0682 787.248 91.7483 792.648 95.1846C797.034 97.8314 800.654 101.577 803.149 106.052C805.643 110.527 806.927 115.576 806.872 120.699V398.698C806.38 403.607 804.613 408.303 801.747 412.319C798.88 416.334 795.012 419.53 790.529 421.59C778.592 428.127 463.465 626.326 419.967 650.536C415.014 653.473 409.384 655.051 403.624 655.109Z",
    fill: "url(#paint0_linear_2370_911)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.984 655.109H403.624C409.347 655.145 414.998 653.673 419.967 650.859C462.651 626.159 778.603 427.959 790.528 421.913C795.015 419.855 798.884 416.66 801.753 412.644C804.622 408.628 806.391 403.932 806.883 399.021V121.01C806.937 116.307 805.874 111.658 803.782 107.445L401.984 328.046V655.109Z",
    fill: "url(#paint1_linear_2370_911)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.588 651.19H398.966C393.303 651.226 387.712 649.769 382.797 646.985C340.568 622.548 27.9805 426.46 16.1826 420.478C11.7443 418.442 7.91595 415.281 5.07745 411.308C2.23895 407.335 0.489131 402.688 0.00183046 397.83V122.78C-0.0511986 118.127 1.00026 113.527 3.06981 109.359L400.588 327.61V651.19Z",
    fill: "url(#paint2_linear_2370_911)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2370_911",
    x1: -0.317392,
    y1: 5.98645,
    x2: 798.982,
    y2: -0.203536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#F38000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#F83C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FC1CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FE08ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2370_911",
    x1: 224.234,
    y1: 586.744,
    x2: 1039.16,
    y2: 135.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE0A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE0A3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2370_911",
    x1: 303.539,
    y1: 469.162,
    x2: -90.248,
    y2: 151.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED6600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2370_911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 806.885,
    height: 655.11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazadaLogo);
export default __webpack_public_path__ + "static/media/lazada_logo.df3d9913d7bd90c3d3ba29a868f67bd8.svg";
export { ForwardRef as ReactComponent };